import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/media";
import { formatDateCn } from "@/utils/media";

interface NewsCardProps {
  item: NewsItem;
  variant?: "default" | "compact";
}

export default function NewsCard({ item, variant = "default" }: NewsCardProps) {
  if (variant === "compact") {
    return (
      <Link to={`/news/${item.id}`} className="group flex cursor-pointer items-start gap-3">
        <div className="h-[62px] w-[92px] shrink-0 overflow-hidden rounded-md bg-background-200">
          <img
            src={item.cover}
            alt={`${item.title} 配图`}
            title={`${item.title} - 日韩影视资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="min-w-0">
          <p className="text-[11px] text-foreground-500">
            {item.category} · {formatDateCn(item.date)}
          </p>
          <h4 className="mt-1 line-clamp-2 text-[13px] font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-700">
            {item.title}
          </h4>
        </div>
      </Link>
    );
  }

  return (
    <Link to={`/news/${item.id}`} className="group flex h-full cursor-pointer flex-col">
      <div className="relative aspect-[16/9] w-full overflow-hidden rounded-lg bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 配图`}
          title={`${item.title} - 日韩影视资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-700 ease-smooth group-hover:scale-[1.04]"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/95 px-2.5 py-1 text-[11px] font-medium text-primary-800">
          {item.category}
        </span>
      </div>
      <div className="mt-4 flex flex-1 flex-col">
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] text-foreground-500">
          <time dateTime={item.date}>{formatDateCn(item.date)}</time>
          <span className="text-background-400">·</span>
          <span>{item.readTime}</span>
        </div>
        <h3 className="mt-2 line-clamp-2 font-heading text-[15px] font-medium leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-500">{item.excerpt}</p>
      </div>
    </Link>
  );
}